import { Box } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@feathr/components';

import {
  SAMPLE_DISPLAY_LENGTH,
  SAMPLE_TITLE_LENGTH,
  truncateSample,
} from './DataImportStepTwo.utils';

import * as styles from './ImportMappingTable.css';

interface IProps {
  /*
   * The first value of this column in the preview: null while the first preview loads, and ''
   * when the column has no value.
   */
  sampleValue: string | null;
}

/** The mapping row's first value from the file, truncated, with the longer value as its title. */
function ImportMappingSampleCell({ sampleValue }: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();

  if (sampleValue === '') {
    return (
      <Text.DefaultMedium className={styles.sampleEmpty} truncate={false}>
        {t('No value in the first rows')}
      </Text.DefaultMedium>
    );
  }
  if (!sampleValue) {
    return null;
  }
  return (
    <Box className={styles.sample} title={truncateSample(sampleValue, SAMPLE_TITLE_LENGTH)}>
      <Text.DefaultRegular truncate={false}>
        {truncateSample(sampleValue, SAMPLE_DISPLAY_LENGTH)}
      </Text.DefaultRegular>
    </Box>
  );
}

export default ImportMappingSampleCell;
